module.exports = __webpack_public_path__ + "img/_5.b7657265.png";